import {
  CHART_ARTIFACT_TYPE,
  CHART_DASHBOARD_ARTIFACT_TYPE,
  isChartArtifactPayload,
  isChartDashboardPayload,
} from '@cotera/api';

/** Short label for a superseded artifact tool output (not the latest inline snippet). */
export function getArtifactEditLabel(
  artifactType: string,
  payload: unknown,
  title: string
): string {
  if (
    artifactType === CHART_DASHBOARD_ARTIFACT_TYPE &&
    isChartDashboardPayload(payload)
  ) {
    const count = payload.charts.length;
    return `Updated ${title} · ${count} ${count === 1 ? 'chart' : 'charts'}`;
  }

  if (artifactType === CHART_ARTIFACT_TYPE && isChartArtifactPayload(payload)) {
    return `Updated ${title}`;
  }

  if (artifactType === 'document') {
    return `Updated ${title}`;
  }

  if (artifactType === 'workflow') {
    return `Updated ${title}`;
  }

  if (artifactType === 'agent') {
    return `Updated ${title}`;
  }

  return `Updated ${title}`;
}
